module.exports = __webpack_public_path__ + "img/hire-expert.34742dc7.svg";